import * as angular from 'angular';

(function () {
    'use strict';

    angular
        .module('app')
        .controller('LandingPageController', LandingPageController);

    function LandingPageController($scope, $interval) {
        var vm = this;

        $scope.router = 1;

        $interval(function () {
            if ($scope.router == 3) {
                $scope.router = 1;
            } else {
                $scope.router++;
            }
        }, 30000);
    }
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/landing_page/landing_page.controller.ts